export { WidgetsModule } from '@ispm/widgets/widgets.module';
